import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import ReactLoading from 'react-loading';

@autobind
class GetStarted extends React.Component {
  state = {
    closeable:true,
  };

  
  // componentWillReceiveProps(nextProps){
  //   if(nextProps.getStarted === true){
  //     this.setState({closeable:true})
  //     setTimeout(()=> this.setState({closeable:false}), 3000 )
  //   }
  // }


  render() {
  

    return (
      <div className={this.props.getStarted ? css(styles.layerTrue) : css(styles.layerFalse)}>
        <div className={this.props.getStarted ? css(styles.popupWrapperTrue) : css(styles.popupWrapperFalse)}>
          {
            // this.state.closeable === true ?
            // <img className={css(styles.close)} onClick={this.props.close} src="../assets/close.svg" alt="close minimaa" />
            // :
            // null
          }
          <div className={css(styles.wrapper)}>
            <img  className={css(styles.img)} src="../assets/instagram.png" alt="instagram logo" />
            <div className={css(styles.title)}>REDIRECTING TO INSTAGRAM</div>
            <div className={css(styles.text)}>We are redirecting you to Instagram Sign In, please wait.</div>
            <ReactLoading type={"bubbles"} color={"#000"} height={35} width={40} />
          </div>
        </div>
      </div>
    );
  }
}


const styles = StyleSheet.create({
  layerTrue:{
    position:"fixed",
    display:"flex",
    top:0,
    bottom:0,
    left:0,
    right:0,
    zIndex:1000,
    justifyContent:"center",
    alignItems:"center",
    transition:"0.3s ease-in",
    background:"rgba(0,0,0,0.4)",
  },
  layerFalse:{
    position:"fixed",
    display:"none",
    top:0,
    bottom:0,
    left:0,
    right:0,
    zIndex:1000,
    justifyContent:"center",
    alignItems:"center",
    transition:"0.3s ease-in",
    background:"rgba(0,0,0,0)",
  },
  popupWrapperTrue:{
    position:"relative",
    transition:"0.2s ease-in-out",
    width:300,
    boxShadow: "rgba(0, 0, 0, 0.0784314) 0px 4px 16px 0px, rgba(0, 0, 0, 0.239216) 0px 24px 96px 0px",
    background:"#fff",
    opacity:1,
    padding:40,
  },
  popupWrapperFalse:{
    position:"relative",
    transition:"0.2s ease-in-out",
    minWidth:300,
    boxShadow: "rgba(0, 0, 0, 0.0784314) 0px 4px 16px 0px, rgba(0, 0, 0, 0.239216) 0px 24px 96px 0px",
    width:300,
    background:"#fff",
    opacity:0,
    padding:50,
    paddingBottom:30,
  },

  title:{
    fontSize:12,
    textAlign:"center",
    lineHeight:"18px",
    marginTop:20,
    fontWeight: 600,
    letterSpacing: "0.190909px",
  },
  text:{
    fontSize:12,
    textAlign:"center",
    lineHeight:"18px",
    marginTop:20,
    letterSpacing: "0.136364px",
    marginBottom:15,
  },
  img:{
    width:44,
  },

  
  wrapper:{
    textAlign:"center",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    flexDirection:"column",
  },
 
  close:{
    position:"absolute",
    width:25,
    
    top:20,
    right:20,
    cursor:"pointer",
  },
 
  
});

export default GetStarted;
